import {GenReportGroup} from '../../../generated/serverModels/GenReportGroup';
import {Report} from './report';

export class ReportGroup extends GenReportGroup {
  public description: string = '';
  public iconWeight: 'fill' | 'regular' = 'regular';

  public override reports: Report[] = [];

  constructor(group?: ReportGroup) {
    super(group);

    if(group) {
      this.reports = group.reports.map(report => new Report(report));
      switch (group.uiHandle) {
        case 'electric':
          this.iconWeight = 'regular';
          break;
        case 'weather':
          this.iconWeight = 'fill';
          break;
        default:
          this.iconWeight = 'regular';
      }
    }

  }

}
